import { render } from "./OverviewCharts.vue?vue&type=template&id=3983cb4c&ts=true"
import script from "./OverviewCharts.vue?vue&type=script&lang=ts"
export * from "./OverviewCharts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__